import { browsingDomainStore } from '../../store';
export const getSelectedSiteIds = () => browsingDomainStore.data.selectedSiteIds;
//# sourceMappingURL=get-selected-site-ids.js.map